import axios from "../util/axios";
import Token from "../util/Token";

// WhatsApp (ai-cct) integration. All endpoints are super-admin-only server-side
// (requireSuperAdminFeature("WhatsApp")). The connection config lives on the
// super-admin Settings page; the message history is proxied live from ai-cct.
const URL = "/cms/v1/whatsapp";
const COMPANY_URL = "/cms/v2/company";

// --- Connection config (base URL + ai-cct API key + enable flag) -------------
async function getConfig() {
  try {
    Token.setAuthToken();
    const { status, data } = await axios.get(`${URL}/config`);
    if (status === 200 && data.success) return data.data;
    return null;
  } catch (error) {
    return null;
  }
}

async function updateConfig(config) {
  Token.setAuthToken();
  const { data } = await axios.put(`${URL}/config`, { config });
  return data?.data;
}

// --- Message history (sent + received), proxied from ai-cct ------------------
async function getConversations(params = {}) {
  Token.setAuthToken();
  const { data } = await axios.get(`${URL}/conversations`, { params });
  return data?.data;
}

async function getMessages(conversationId, params = {}) {
  Token.setAuthToken();
  const { data } = await axios.get(
    `${URL}/conversations/${conversationId}/messages`,
    { params }
  );
  return data?.data;
}

// --- Approved templates (to map to notification triggers) --------------------
async function getTemplates(params = {}) {
  try {
    Token.setAuthToken();
    const { status, data } = await axios.get(`${URL}/templates`, { params });
    if (status === 200 && data.success) return data.data;
    return [];
  } catch (error) {
    return [];
  }
}

// --- Manual / test send ------------------------------------------------------
async function sendMessage({ to, body, channel, templateName, params }) {
  Token.setAuthToken();
  const payload = { to };
  if (templateName) {
    payload.template_name = templateName;
    payload.params = Array.isArray(params) ? params : [];
  } else {
    payload.body = body;
    payload.channel = channel;
  }
  const { data } = await axios.post(`${URL}/send`, payload);
  return data?.data;
}

// --- Per-company "WhatsApp notifications enabled" toggle (super admin) --------
async function getCompanyWhatsappConfig(companyId) {
  try {
    Token.setAuthToken();
    const { status, data } = await axios.get(
      `${COMPANY_URL}/${companyId}/whatsapp-config`
    );
    if (status === 200 && data.success) {
      return { whatsappEnabled: data.data?.whatsappEnabled === true };
    }
    return { whatsappEnabled: false };
  } catch (error) {
    return { whatsappEnabled: false };
  }
}

async function updateCompanyWhatsappConfig(companyId, whatsappEnabled) {
  Token.setAuthToken();
  const { data } = await axios.put(
    `${COMPANY_URL}/${companyId}/whatsapp-config`,
    { whatsappEnabled: whatsappEnabled === true }
  );
  return { whatsappEnabled: data?.data?.whatsappEnabled === true };
}

const whatsappService = {
  getConfig,
  updateConfig,
  getConversations,
  getMessages,
  getTemplates,
  sendMessage,
  getCompanyWhatsappConfig,
  updateCompanyWhatsappConfig,
};
export default whatsappService;
